const messageSearch = (messages, keyword) => {
  const searchTerm = keyword.toLowerCase();
  return messages.filter((message) => {
    return (
      message.message.toLowerCase().match(new RegExp(searchTerm, 'g')) ||
      message.user.name.toLowerCase().match(new RegExp(searchTerm, 'g')) ||
      message.user.username.toLowerCase().match(new RegExp(searchTerm, 'g'))
    );
  });
};

export default messageSearch;
